/**
 * StateSelect — single Shadcn `<Select>` bound to the shared US_STATES list.
 *
 * Displays the full state name in the trigger, but writes the USPS 2-letter
 * code back to the parent (so the DB stays compact + filterable). Handles
 * legacy free-text values by normalising them via `normaliseStateInput`.
 *
 * Props:
 *   value      — current value (either "MN" or "Minnesota")
 *   onChange   — receives the 2-letter code
 *   placeholder — override the default "Select a state"
 *   testId     — override the data-testid on the trigger
 *   disabled   — pass through
 */
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from "@/components/ui/select";
import { US_STATES, normaliseStateInput } from "@/lib/usStates";

export default function StateSelect({
  value,
  onChange,
  placeholder = "Select a state",
  testId = "state-select",
  disabled = false,
}) {
  const normalised = value ? normaliseStateInput(value) : "";
  return (
    <Select
      value={normalised || undefined}
      onValueChange={onChange}
      disabled={disabled}
    >
      <SelectTrigger data-testid={testId}>
        <SelectValue placeholder={placeholder} />
      </SelectTrigger>
      <SelectContent className="max-h-72">
        {US_STATES.map((s) => (
          <SelectItem key={s.code} value={s.code} data-testid={`state-option-${s.code}`}>
            {s.name}
          </SelectItem>
        ))}
      </SelectContent>
    </Select>
  );
}
